import React from 'react';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';

const SelectEtapaTorneo = (props) => {
  const etapas = props.etapas || [];
  const etapaSeleccionada = props.etapaSeleccionada;
  const estilo = props.estilo;

  const lista = etapas.map((etapaTorneo) => ({
    ...etapaTorneo,
    descripcionEtapa: etapaTorneo.etapa?.descripcion || '',
  }));

  const itemSeleccionado = lista.find(
    (etapaTorneo) => etapaSeleccionada && etapaTorneo.id === etapaSeleccionada.id
  );
  const valorActual = itemSeleccionado?.descripcionEtapa || lista[0]?.descripcionEtapa || '';

  const onItemElegido = (item) => {
    props.onEtapaSeleccionada(item);
  };

  return (
    <ComboSelector
      estilo={estilo}
      lista={lista}
      valorActual={valorActual}
      campoClave={TipoClave.ID}
      campoDescripcion="descripcionEtapa"
      onItemElegido={onItemElegido}
    />
  );
};

export default SelectEtapaTorneo;
